var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2430 5114 c-318 -41 -573 -161 -793 -373 -487 -469 -539 -1230 -121 -1767 401 -516 1135 -662 1699 -337 498 287 755 845 649 1406 -99 519 -517 941 -1037 1048 -99 20 -318 33 -397 23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490 2350 c-443 -78 -849 -353 -1102 -746 -53 -83 -118 -224 -118 -257 0 -66 190 -334 370 -521 439 -457 981 -729 1605 -807 130 -17 492 -16 620 0 506 65 956 254 1345 565 121 96 358 341 452 466 105 141 188 275 188 306 0 30 -56 153 -105 229 -171 267 -409 485 -676 618 -195 97 -438 164 -561 155 -42 -3 -70 -13 -110 -38 -144 -91 -190 -116 -270 -151 -199 -87 -402 -125 -618 -116 -276 11 -508 85 -739 237 -50 33 -103 62 -118 66 -16 3 -35 7 -43 9 -8 2 -62 -5 -120 -15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d7de5fddaea8216edf5d2cb6ae25540d.svg";
export { ForwardRef as ReactComponent };